import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router';
import { Rutas } from './routes/rutas.js';
import { CLAVE_IDIOMA, esIdioma, idiomaInicial, type Idioma } from './i18n/index.js';
import { pedirSesion } from './common/services/api.js';

/**
 * El idioma se decide una vez al arrancar y se escribe en `<html lang>`, que es de donde lo leen
 * los lectores de pantalla y los traductores del navegador.
 *
 * La sesión empieza a pedirse al cargar. Si alguien pregunta antes de recibirla, el cliente del
 * API espera esa misma petición antes de enviar la consulta.
 */
export function App() {
  const [idioma, setIdioma] = useState<Idioma>('es');

  useEffect(() => {
    let guardado: string | null = null;
    try {
      guardado = localStorage.getItem(CLAVE_IDIOMA);
    } catch {
      // Un navegador con el almacenamiento bloqueado sigue pudiendo usar Athena, en español.
    }
    const delEnlace = window.location.pathname === '/auth/retorno' ? new URLSearchParams(window.location.search).get('idioma') : null;
    const elegido = esIdioma(delEnlace) ? delEnlace : idiomaInicial(guardado, navigator.language);
    if (esIdioma(delEnlace)) {
      try {
        localStorage.setItem(CLAVE_IDIOMA, delEnlace);
      } catch {
        // El idioma del enlace vale también sin almacenamiento.
      }
    }
    setIdioma(elegido);
    document.documentElement.lang = elegido;
    void pedirSesion();
  }, []);

  /** Cambiar de idioma lo recuerda para la próxima visita y actualiza `<html lang>`. */
  const cambiarIdioma = useCallback((nuevo: Idioma) => {
    setIdioma(nuevo);
    document.documentElement.lang = nuevo;
    try {
      localStorage.setItem(CLAVE_IDIOMA, nuevo);
    } catch {
      // Sin almacenamiento no se recuerda, pero el cambio vale para esta visita.
    }
  }, []);

  return (
    <BrowserRouter>
      <Rutas idioma={idioma} onCambiarIdioma={cambiarIdioma} />
    </BrowserRouter>
  );
}

export { CLAVE_IDIOMA };
